/* eslint-disable jsx-a11y/anchor-is-valid */
import _ from 'lodash';
import React, { useMemo, useRef, useState } from 'react';
import { Button } from 'src/@vymo/ui/atoms';
import { Banner } from 'src/@vymo/ui/blocks';
import PojoModal from './pojoModal';
import styles from '../index.module.scss';

function JSONControls({ data, onChange, error }) {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const downloadInputRef = useRef<HTMLAnchorElement>(null);
  const [alertData, setAlertData] = useState<{
    type: 'error' | 'success';
    message: string;
  } | null>(null);
  const [openPojoGenerator, setPojoGenerator] = useState<boolean>(false);

  const exportUrl = useMemo(() => {
    const jsonString = JSON.stringify(data, null, 4); // formatted with spacing
    const blob = new Blob([jsonString], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    return url;
  }, [data]);
  const handleImport = (event) => {
    const file = event.target.files?.[0];
    if (!file) {
      return;
    }
    if (file.type !== 'application/json') {
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const content = e.target?.result;
        if (typeof content === 'string') {
          const parsedJson = JSON.parse(content);
          onChange(parsedJson);
          setAlertData({
            type: 'success',
            message: 'Imported successfully.',
          });
        }
      } catch (err) {
        setAlertData({
          type: 'error',
          message:
            'Error parsing JSON file. Please check the file or its format.',
        });
      }
    };

    reader.readAsText(file);
  };
  const handleExport = () => {
    downloadInputRef.current?.click();
    setTimeout(() => {
      URL.revokeObjectURL(exportUrl);
      setAlertData({
        type: 'success',
        message: 'Exported successfully.',
      });
    }, 1000);
  };
  const handleCopy = (str) => {
    navigator.clipboard
      .writeText(str)
      .then(() => {
        setAlertData({
          type: 'success',
          message: 'Data copied to clipboard successfully.',
        });
      })
      .catch(() => {
        setAlertData({
          type: 'error',
          message: 'Failed to copy data to clipboard.',
        });
      });
  };

  return (
    <div className={styles.jsonPlayground__topControls}>
      {alertData?.message && (
        <Banner
          message={alertData?.message}
          variant={alertData?.type}
          duration={2000}
          banner
          position="topCenter"
        />
      )}
      <Button
        type="primary"
        className={styles.jsonPlayground__topControls__btn}
        onClick={() => fileInputRef.current?.click()}
      >
        <input
          type="file"
          ref={fileInputRef}
          onChange={handleImport}
          accept=".json"
          style={{ display: 'none' }}
        />
        Import
      </Button>{' '}
      <Button
        type="primary"
        className={styles.jsonPlayground__topControls__btn}
        onClick={handleExport}
        disabled={error || _.isEmpty(data)}
      >
        <a
          href={exportUrl}
          ref={downloadInputRef}
          style={{ display: 'none' }}
          download="export.json"
        >
          Download
        </a>
        Export
      </Button>{' '}
      <Button
        type="primary"
        className={styles.jsonPlayground__topControls__btn}
        onClick={() => handleCopy(JSON.stringify(data, null, 4))}
        disabled={error || _.isEmpty(data)}
      >
        Copy
      </Button>
      <Button
        type="primary"
        className={styles.jsonPlayground__topControls__btn}
        onClick={() => setPojoGenerator(true)}
        disabled={error || _.isEmpty(data)}
      >
        Generate POJO
      </Button>
      <PojoModal
        open={openPojoGenerator}
        onClose={() => setPojoGenerator(false)}
        data={data}
        onCopy={handleCopy}
      />
    </div>
  );
}

export default JSONControls;
